/**
 * Formata uma string de número de telefone para o padrão brasileiro.
 * Ex: (XX) XXXX-XXXX ou (XX) XXXXX-XXXX
 * @param phone - A string do telefone a ser formatada. Pode conter ou não caracteres especiais.
 * @returns A string do telefone formatada ou uma string vazia se a entrada for inválida.
 */
export const formatPhone = (phone: string): string => {
  if (!phone) {
    return '';
  }

  // 1. Remove todos os caracteres que não são dígitos
  const digitsOnly = phone.replace(/\D/g, '');

  // 2. Aplica a máscara para celular (XX) XXXXX-XXXX
  if (digitsOnly.length === 11) {
    return digitsOnly.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  // 3. Aplica a máscara para telefone fixo (XX) XXXX-XXXX
  if (digitsOnly.length === 10) {
    return digitsOnly.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }

  // 4. Se não corresponder a nenhum formato, retorna os dígitos limpos (ou a string original)
  return digitsOnly;
};
